export default __webpack_public_path__ + "static/media/power.37c80380.png";